import { render } from "./AposTiptapTableControls.vue?vue&type=template&id=71f335a2&scoped=true"
import script from "./AposTiptapTableControls.vue?vue&type=script&lang=js"
export * from "./AposTiptapTableControls.vue?vue&type=script&lang=js"

import "./AposTiptapTableControls.vue?vue&type=style&index=0&id=71f335a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f335a2"],['__file',"rich-text-widget/ui/apos/components/AposTiptapTableControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71f335a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71f335a2', __exports__)) {
    api.reload('71f335a2', __exports__)
  }
  
  module.hot.accept("./AposTiptapTableControls.vue?vue&type=template&id=71f335a2&scoped=true", () => {
    api.rerender('71f335a2', render)
  })

}


export default __exports__